import { axiosConsumer } from "../consumer/axios-consumer";

const resource = '/api/settings';

const apiListLockPolicies = async ()=> new Promise((resolve, reject) => axiosConsumer().get(`${resource}/lock-policies`)
  .then((res)=> resolve(res.data))
  .catch((e)=> reject(e.response.data)));

const apiGetSettings = async ()=> new Promise((resolve, reject)=> axiosConsumer().get(`${resource}/`)
  .then((res)=> resolve(res.data))
  .catch((e)=> reject(e.response.data)));

const apiUpdateSettings = async (req)=> new Promise((resolve, reject)=> axiosConsumer().patch(`${resource}/edit`, req)
  .then((res)=> resolve(res.data))
  .catch((e)=> reject(e.response.data)));

export const SettingsRepository = {
  listLockPolicies: apiListLockPolicies,
  find: apiGetSettings,
  update: apiUpdateSettings
};